import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GuidService {

  constructor() { }

  /**
   * It generates a random GUID.
   * @returns A random string of characters.
   */
  guid(): string {
    return ([1e7] as any + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    // tslint:disable-next-line:no-bitwise
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }
}
